import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import TestimonialsSlider from '../components/TestimonialsSlider'
import { getAssetUrl } from '../lib/utils'

export default function HomePage() {
  const [featuredTreatments, setFeaturedTreatments] = useState([])
  const [frontpageTestimonials, setFrontpageTestimonials] = useState([
    {
      id: '35f7d4be-04c7-4613-be60-53bf2300bf33',
      name: 'Susanne 51',
      category: 'Stress & Søvn',
      quote: '<p>Jeg kom hos Trine midt i september. Træt i sjæl og sind af mit arbejde og havde lige sygemeldt mig med mange stress symptomer. Kunne bla overhovedet ikke sove om natten... Allerede efter 1 gang blev jeg lidt mere rolig og fredfyldt i sindet... Efter 3 gange stoppede jeg fyldt med nyt mod, energi og en meget forbedret søvn.</p><p>Jeg ved ikke hvad Trine gør? Men hun er et fantastisk sødt og imødekommende menneske. Hun healer med sin tilstedeværelse og vejledning. Samtidig arbejder hun med hypnosen, som er fantastisk beroligende.</p>',
      featured_on_frontpage: true,
    },
    {
      id: '7be122c4-c6d1-4c45-b5cd-c50f82a0e75c',
      name: 'Ani på 15',
      category: 'Hjemve & Angst',
      quote: '<p>Da jeg sidste år hørte, at vi skulle til Berlin med årgangen, havde jeg slet ikke set det som en mulighed, at jeg skulle afsted med skolen... Men da jeg kom til behandling hos dig, åbnede der sig en helt ny verden for mig. Nu når jeg allerede er 15 år, troede jeg aldrig jeg ville komme til at kunne sove ude.</p><p>Turen til Berlin gik så godt som det kunne. Jeg kunne på intet tidspunkt i de 4 dage mærke en snert af frygt. Du har virkelig forandret mit liv. Mange 1000 tak!</p>',
      featured_on_frontpage: true,
    },
    {
      id: 'c4156cf4-0895-4617-b7c6-0a2ca45b5fbe',
      name: 'Gerthie på 40',
      category: 'Vægttab',
      quote: '<p>Jeg startede min indre rejse sammen med Trine for små 4 år siden. På det tidspunkt vejede jeg over 100 kg, var træt af mange års yo-yo vægt... Sammen har vi kigget på årsager, ulysten til motion og den uhensigtsmæssige adfærd... Vægten er faldet 37 kg og min kost er fuld af sunde bevidste valg.</p><p>Hos Trine er der ingen hokus pokus… men der er ærlighed, nærvær, vejledning, rum til at nå egne konklusioner og masser af respekt.</p>',
      featured_on_frontpage: true,
    },
    {
      id: '4d66904f-696d-4c2a-ac55-82814040a058',
      name: 'Matilde på 21',
      category: 'Flyskræk & Angst',
      quote: '<p>Lovede jo lige at give en tilbagemelding på flyturen til og fra egypten. Det gik super fint det hele. Var slet ikke lige så panisk som jeg plejer at være. Kunne dog godt stadig mærke det, men jeg følte jeg havde kontrol over det. Mange tak for din super gode hjælp 🙂</p>',
      featured_on_frontpage: true,
    },
    {
      id: 'ef7941c1-6ee7-419d-b38c-b6fba54b905a',
      name: 'Nikolai på 10',
      category: 'Børn & Angst',
      quote: '<p>Jeg har været hos Trine for at få hjælp til at jeg har været utryg, ked af det, angst og at jeg følte der var spøgelser som fulgte efter mig hele tiden... nu hvor jeg har fået hendes hjælp er jeg blevet meget mere glad og er ikke ked af det mere. Spøgelserne ser jeg heller ikke til mere... jeg er blevet en helt anden og glad dreng igen. Tak for hjælpen Trine.</p>',
      featured_on_frontpage: true,
    },
    {
      id: 'eff56965-dd31-4126-97c1-85e27547315b',
      name: 'Christian 20 år',
      category: 'Angst & Depression',
      quote: '<p>Jeg havde længe gået rundt med angst og depression, da jeg startede i behandling hos Trine. Jeg havde prøvet mange ting, men der var ikke rigtigt noget der hjalp. Allerede efter første behandling kunne jeg mærke en forskel. Man føler sig tryg og glad, og man bliver fyldt op med energi. I dag lider jeg ikke længere af angst. Det er ligesom at få et helt nyt liv.</p>',
      featured_on_frontpage: true,
    },
  ])

  useEffect(() => {
    // Fetch treatments from CMS
    async function loadCmsData() {
      try {
        const res = await fetch('/_api/public/content/treatments')
        if (res.ok) {
          const data = await res.json()
          const items = Array.isArray(data) ? data : data.items || []
          // Filter to featured treatments (or first 4)
          const featured = items.filter((t) => t.is_featured)
          setFeaturedTreatments(featured.length > 0 ? featured : items.slice(0, 4))
        }
      } catch (err) {
        console.error('Fejl ved indlæsning af behandlinger:', err)
      }

      try {
        const res = await fetch('/_api/public/content/testimonials')
        if (res.ok) {
          const data = await res.json()
          const items = Array.isArray(data) ? data : data.items || []
          const featured = items.filter((t) => t.featured_on_frontpage)
          setFrontpageTestimonials(featured.length > 0 ? featured : items.slice(0, 6))
        }
      } catch (err) {
        console.error('Fejl ved indlæsning af udtalelser:', err)
      }
    }
    loadCmsData()
  }, [])

  return (
    <>
      <MetaTags
        title="Trine Rosendahl - Certificeret hypnoterapeut i Holstebro"
        description="Jeg er certificeret hypnoterapeut i Holstebro og har gennem de sidste 12 år arbejdet med både børn, unge og voksne og kan også hjælpe dig som hypnoterapeut."
        image="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1005-1-scaled.jpg"
        canonicalUrl="https://trine-rosendal.dk/"
      />

      <div className="space-y-20 sm:space-y-28 lg:space-y-32 pb-20">
        {/* HERO SECTION - CALM & MINIMAL */}
        <section className="relative pt-6 sm:pt-12 lg:pt-16 pb-8">
          <div className="mx-auto max-w-6xl px-5 sm:px-6">
            <div className="relative rounded-3xl border border-[#DFE7D6] bg-gradient-to-br from-[#EEF4E8] via-[#FAF7EC] to-[#E9F0E2] p-6 sm:p-10 lg:p-14 shadow-sm">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
              {/* Left Column: Heading, calm prose, and 2 focal CTAs */}
              <div className="lg:col-span-7 space-y-6">
                <div className="inline-flex items-center gap-2 rounded-full border border-[#D5E0CC] bg-white/80 px-3.5 py-1 text-xs text-[#44563B] font-medium w-fit shadow-2xs">
                  <span className="flex h-2 w-2 rounded-full bg-[#F5D154] animate-pulse" />
                  <span>Certificeret hypnoterapeut & healer i Holstebro</span>
                </div>

                <h1 className="font-serif text-4xl sm:text-5xl lg:text-[56px] font-normal tracking-tight text-[#242E1F] leading-[1.12]">
                  Jeg kan lære dig at give slip
                </h1>

                <p className="text-base sm:text-lg text-[#3E4E37] leading-relaxed max-w-xl">
                  Du har allerede de følelsesmæssige ressourcer, du tror du mangler. Uanset hvad du kæmper med, findes nøglen til fremgang inde i dig. Via Hypnoterapien hjælper jeg dig med at forløse det, der modarbejder og dræner.
                </p>

                <div className="pt-1 text-sm text-[#5B6D53]">
                  <span>V. Trine Rosendal · Praksis på fuldtid siden 2007</span>
                </div>

                {/* Primary Actions: Just 2 clear, uncluttered choices */}
                <div className="flex flex-wrap items-center gap-3.5 pt-2">
                  <a
                    href="https://system.easypractice.net/book/online-booking-16"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 rounded-full bg-[#F5D154] hover:bg-[#EABF35] px-7 py-3.5 text-sm font-semibold text-[#1E2718] shadow-xs transition duration-200 active:scale-[0.98]"
                  >
                    <i className="fa-solid fa-calendar-check text-xs text-[#1E2718]/80" aria-hidden="true" />
                    <span>Book tid online</span>
                  </a>

                  <Link
                    to="/behandlinger"
                    className="inline-flex items-center gap-2 rounded-full border border-[#5C7A4F] bg-white px-6 py-3.5 text-sm font-medium text-[#5C7A4F] transition hover:bg-[#EEF3E8]"
                  >
                    <span>Se behandlinger</span>
                    <i className="fa-solid fa-arrow-right text-xs text-[#5C7A4F]" aria-hidden="true" />
                  </Link>
                </div>
              </div>

              {/* Right Column: Clean, calm photo of Trine in the clinic */}
              <div className="lg:col-span-5">
                <div className="relative mx-auto max-w-sm lg:max-w-none">
                  <div className="overflow-hidden rounded-3xl border border-[#DFE6D5] bg-white shadow-sm">
                    <img
                      src="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/image.png"
                      alt="Trine Rosendal i klinikken i Holstebro"
                      className="w-full h-[400px] sm:h-[480px] object-cover object-top"
                    />
                    <div className="p-4 bg-[#F6F8F3] border-t border-[#DFE6D5] flex items-center justify-between text-xs text-[#5C6E52]">
                      <span className="font-medium text-[#222E1D]">
                        Klinikken i Holstebro
                      </span>
                      <span>Prins Burisvej 41.A</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        {/* HYPNOTERAPI I FOKUS - ENKELT & NÆRVÆRENDE */}
        <section className="mx-auto max-w-6xl px-5 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
            <span className="text-xs uppercase tracking-widest text-[#556B48] font-medium">
              Metode & tilgang
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl font-normal text-[#222E1D] mt-2">
              Hypnoterapi tilpasset netop dig
            </h2>
            <p className="text-sm sm:text-base text-[#4D5E46] mt-3">
              Hypnose er en integreret del af hypnoterapi. Behandlingen tilpasses altid det enkelte menneske for trygge og holdbare resultater.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* 1. Hypnoterapi */}
            <div className="flex flex-col justify-between rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-8 transition hover:border-[#F5D154]/70 hover:shadow-xs">
              <div className="space-y-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#E2EBD9] text-[#5C7A4F]">
                  <i className="fa-solid fa-brain text-base" aria-hidden="true" />
                </div>
                <h3 className="font-serif text-2xl font-normal text-[#222E1D]">
                  Hypnoterapi
                </h3>
                <p className="text-xs sm:text-sm text-[#4D5E46] leading-relaxed">
                  Arbejd direkte med det ubevidste sind. Forløs angst, uhensigtsmæssige vaner, lavt selvværd, stress, fobier og uro i en helt naturlig, tryg og afslappet tilstand.
                </p>
              </div>

              <div className="pt-6 border-t border-[#DFE7D6] mt-6">
                <Link
                  to="/hypnose"
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#5C7A4F] hover:text-[#222E1D] transition"
                >
                  <span>Læs mere om hypnoterapi</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* 2. Individuelt & Helhedsorienteret forløb */}
            <div className="flex flex-col justify-between rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-8 transition hover:border-[#F5D154]/70 hover:shadow-xs">
              <div className="space-y-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#E2EBD9] text-[#5C7A4F]">
                  <i className="fa-solid fa-sparkles text-base" aria-hidden="true" />
                </div>
                <h3 className="font-serif text-2xl font-normal text-[#222E1D]">
                  17 behandlingsområder & skræddersyet hjælp
                </h3>
                <p className="text-xs sm:text-sm text-[#4D5E46] leading-relaxed">
                  Uanset om du søger hjælp til en specifik fobi, eksamensangst, søvnbesvær eller noget helt andet, skræddersys hver session med nærvær, samtale og beroligende healing.
                </p>
              </div>

              <div className="pt-6 border-t border-[#DFE7D6] mt-6">
                <Link
                  to="/behandlinger"
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#5C7A4F] hover:text-[#222E1D] transition"
                >
                  <span>Se alle 17 behandlingsområder</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* HVAD KAN JEG HJÆLPE MED? - OVERSKUELIG LISTE */}
        <section className="mx-auto max-w-6xl px-5 sm:px-6">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
            <div className="max-w-xl">
              <span className="text-xs uppercase tracking-widest text-[#556B48] font-medium">
                Behandlingsområder
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl font-normal text-[#2E1D2B] mt-1.5">
                Hvad kan jeg hjælpe dig med?
              </h2>
              <p className="text-sm text-[#4F5E48] mt-2 leading-relaxed">
                Her er et udvalg af de problemstillinger, jeg oftest behandler. Find din situation eller se den fulde oversigt.
              </p>
            </div>

            <Link
              to="/behandlinger"
              className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-[#5C7A4F] hover:text-[#2A1826] underline underline-offset-4 self-start sm:self-auto"
            >
              <span>Se alle behandlinger ({featuredTreatments.length > 4 ? featuredTreatments.length : 17})</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>

          {/* Clean 4-card grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {featuredTreatments.slice(0, 4).map((t) => {
              const slug = typeof t.slug === 'object' ? t.slug?._ : t.slug
              const imgUrl = Array.isArray(t.hero_image) ? t.hero_image[0] : t.hero_image
              return (
                <article
                  key={t.id || slug}
                  className="group flex flex-col justify-between overflow-hidden rounded-2xl border border-[#DFE6D5] bg-[#F6F8F3] transition duration-200 hover:border-[#CFB9CB] hover:shadow-xs"
                >
                  <div>
                    {imgUrl && (
                      <div className="aspect-16/10 w-full overflow-hidden bg-[#DFE6D5]">
                        <img
                          src={getAssetUrl(imgUrl, { width: 600, quality: 80 })}
                          alt={t.title}
                          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-103"
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.src = imgUrl
                          }}
                        />
                      </div>
                    )}
                    <div className="p-5 space-y-2">
                      <span className="text-[11px] font-medium uppercase tracking-wider text-[#6B7E62]">
                        {t.category_name || 'Behandling'}
                      </span>
                      <h3 className="font-serif text-xl font-normal text-[#222E1D] group-hover:text-[#5c7a4f] transition-colors">
                        {t.title}
                      </h3>
                      <p className="text-xs text-[#4D5E46] leading-relaxed line-clamp-3">
                        {t.short_description}
                      </p>
                    </div>
                  </div>

                  <div className="p-5 pt-0 mt-2">
                    <Link
                      to={`/behandlinger/${slug}`}
                      className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#5C7A4F] group-hover:text-[#222E1D] transition-colors"
                    >
                      <span>Læs mere</span>
                      <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                    </Link>
                  </div>
                </article>
              )
            })}
          </div>
        </section>

        {/* OM TRINE - TILLID & NÆRVÆR */}
        <section className="mx-auto max-w-6xl px-5 sm:px-6">
          <div className="rounded-3xl border border-[#DFE6D5] bg-[#F6F8F3] p-8 sm:p-12 lg:p-14">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
              <div className="lg:col-span-5">
                <div className="overflow-hidden rounded-2xl border border-[#DFE6D5] bg-white">
                  <img
                    src="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/image.png"
                    alt="Trine Rosendal, certificeret hypnoterapeut og healer"
                    className="w-full h-[380px] sm:h-[440px] object-cover object-top"
                  />
                  <div className="p-3.5 bg-[#F6F8F3] border-t border-[#DFE6D5] text-xs text-[#5C6E52] flex items-center justify-between">
                    <span className="font-medium text-[#222E1D]">Trine Rosendal</span>
                    <span>Holstebro · Siden 2007</span>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-7 space-y-5">
                <span className="text-xs uppercase tracking-widest text-[#556B48] font-medium">
                  Om Trine Rosendal
                </span>
                <h2 className="font-serif text-3xl sm:text-4xl font-normal text-[#222E1D]">
                  Et personligt, ærligt og trygt samarbejde
                </h2>

                <div className="space-y-3.5 text-sm sm:text-base text-[#4D5E46] leading-relaxed">
                  <p>
                    Mit navn er Trine Rosendal. Jeg er uddannet certificeret hypnotisør og hypnoterapeut, og har siden 2007 drevet min klinik i Holstebro på fuldtid.
                  </p>
                  <p>
                    Hele mit liv har jeg kunnet fornemme mennesker, stemninger og følelser tydeligere end de fleste. Det er en særlig sensitivitet og empati, som jeg gennem 17 år har forfinet til at hjælpe andre med at finde ind til kernen af det, der spænder ben.
                  </p>
                  <p className="text-xs sm:text-sm text-[#5C6E52]">
                    Vigtigst af alt: Jeg generaliserer aldrig. Hvert eneste forløb tager udgangspunkt i præcis dér, hvor du er, og hvad du har brug for.
                  </p>
                </div>

                <div className="pt-2 flex flex-wrap items-center gap-4">
                  <Link
                    to="/profil"
                    className="inline-flex items-center gap-2 rounded-full bg-[#5C7A4F] px-6 py-3 text-xs sm:text-sm font-medium text-white transition hover:bg-[#455C3A]"
                  >
                    <span>Læs hele min profil</span>
                    <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                  </Link>
                  <Link
                    to="/priser"
                    className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-medium text-[#5C7A4F] hover:text-[#222E1D] underline underline-offset-4"
                  >
                    <span>Se priser og vilkår</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* UDTALELSER */}
        <section className="mx-auto max-w-6xl px-5 sm:px-6">
          <div className="rounded-3xl border border-[#DFE6D5] bg-[#F6F8F3] p-6 sm:p-10 lg:p-12 space-y-8">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
              <div>
                <span className="text-xs uppercase tracking-widest text-[#556B48] font-medium">
                  Klienternes erfaringer
                </span>
                <h2 className="font-serif text-2xl sm:text-3xl font-normal text-[#222E1D] mt-1">
                  Udvalgte forløbshistorier & udtalelser
                </h2>
              </div>
              <Link
                to="/referencer"
                className="text-xs sm:text-sm font-medium text-[#5C7A4F] hover:text-[#222E1D] underline underline-offset-4 flex items-center gap-1.5"
              >
                <span>Se alle referencer</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </Link>
            </div>

            {/* Supplerende udvalgte udtalelser */}
            <TestimonialsSlider testimonials={frontpageTestimonials} />
          </div>
        </section>

        {/* HYPNOSE FORKLARING & VIDEO */}
        <section className="mx-auto max-w-6xl px-5 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-6 space-y-4">
              <span className="text-xs uppercase tracking-widest text-[#556B48] font-medium">
                Tryghed ved behandling
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl font-normal text-[#242E1F]">
                Hvad er terapeutisk hypnose?
              </h2>
              <div className="space-y-3 text-sm sm:text-base text-[#563F50] leading-relaxed">
                <p>
                  Terapeutisk hypnose har intet at gøre med scene-hypnose. Det er en rolig og helt naturlig tilstand af fokuseret opmærksomhed, hvor krop, hjerne og nervesystem får ro til at stabilisere sig.
                </p>
                <p>
                  Under hele behandlingen kan du høre og huske alt. Du er i fuld kontrol og samarbejder med mig i dit eget rolige tempo.
                </p>
              </div>

              <div className="pt-2">
                <Link
                  to="/hypnose"
                  className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-[#5C7A4F] hover:text-[#2A1826] underline underline-offset-4"
                >
                  <span>Læs mere om hvad der sker under hypnose</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
              </div>
            </div>

            <div className="lg:col-span-6">
              <div className="rounded-3xl border border-[#DFE6D5] bg-[#F6F8F3] p-7 sm:p-9 shadow-xs space-y-5">
                <div className="flex items-center gap-3 text-sm font-semibold text-[#2B3824]">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#E7EEDF] text-[#5C7A4F]">
                    <i className="fa-solid fa-shield-heart text-base" aria-hidden="true" />
                  </div>
                  <span>Trygge rammer i klinikken</span>
                </div>
                
                <ul className="space-y-3.5 text-sm text-[#4D5E46] leading-relaxed">
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-xs text-[#5C7A4F] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Du hører og husker alt:</strong> Hypnose er en helt naturlig, afslappet tilstand med skærpet fokus.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-xs text-[#5C7A4F] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>100% i kontrol:</strong> Du kan til enhver tid tale, åbne øjnene og styre tempoet sammen med mig.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-xs text-[#5C7A4F] mt-1 shrink-0" aria-hidden="true" />
                    <span><strong>Ingen scene-hypnose:</strong> Målet er terapeutisk forløsning og tryg, varig forandring.</span>
                  </li>
                </ul>

                <div className="pt-2 border-t border-[#DFE6D5] text-xs text-[#5C6E52] flex items-center justify-between">
                  <span>Praksis på fuldtid siden 2007</span>
                  <span className="font-medium text-[#222E1D]">Holstebro</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
